export const LIGHT_THEME = 'light';
export const DARK_THEME = 'dark';

const LIGHT_START_HOUR = 7;
const LIGHT_END_HOUR = 19;

const THEME_META_COLORS = {
  [LIGHT_THEME]: '#f8fbff',
  [DARK_THEME]: '#0d1117',
};

const CHART_THEME = {
  [LIGHT_THEME]: {
    stroke: '#1a73e8',
    fill: 'rgba(26, 115, 232, 0.14)',
    pointBackground: '#ffffff',
    grid: 'rgba(15, 23, 42, 0.08)',
    ticks: 'rgba(95, 99, 104, 0.94)',
    tooltipBackground: '#ffffff',
    tooltipBorder: 'rgba(15, 23, 42, 0.08)',
    tooltipText: '#1f2937',
    palette: ['#1a73e8', '#34a853', '#fbbc05', '#d93025'],
  },
  [DARK_THEME]: {
    stroke: '#8ab4f8',
    fill: 'rgba(138, 180, 248, 0.18)',
    pointBackground: '#111827',
    grid: 'rgba(255, 255, 255, 0.08)',
    ticks: 'rgba(238, 242, 248, 0.72)',
    tooltipBackground: '#111827',
    tooltipBorder: 'rgba(255, 255, 255, 0.08)',
    tooltipText: '#f8fafc',
    palette: ['#8ab4f8', '#81c995', '#fbbc05', '#f28b82'],
  },
};

export const getThemeModeFromDate = (date = new Date()) => {
  const hour = date.getHours();
  return hour >= LIGHT_START_HOUR && hour < LIGHT_END_HOUR ? LIGHT_THEME : DARK_THEME;
};

export const getThemeMetaColor = (theme) => THEME_META_COLORS[theme] || THEME_META_COLORS[DARK_THEME];

export const getChartTheme = (theme) => CHART_THEME[theme] || CHART_THEME[DARK_THEME];

export const applyThemeToDocument = (theme) => {
  if (typeof document === 'undefined') {
    return;
  }

  const resolvedTheme = theme === LIGHT_THEME ? LIGHT_THEME : DARK_THEME;
  const root = document.documentElement;
  root.dataset.theme = resolvedTheme;
  root.style.colorScheme = resolvedTheme;

  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta) {
    themeColorMeta.setAttribute('content', getThemeMetaColor(resolvedTheme));
  }
};
